import React from "react";
import {
  getNameOfBracket,
  getTrophyUrlForNumberOfMatches,
} from "../../../publicFunctions/publicHelpers/finalShowdownNaming";
import {
  getLaneBackgroundColor,
  getPseudoLaneNumber,
  isThisLaneLeftSide,
  numberOfMatchesForLane,
} from "../../../publicFunctions/publicHelpers/tournamentViewHelper";

function TournamentLaneHeader({ totalLanes, sizes, nightMode }) {
  // Render a header for each lane
  const laneHeaders = [];
  for (let lane = 1; lane <= totalLanes; lane++) {
    const pseudoLane = getPseudoLaneNumber(
      isThisLaneLeftSide(lane, totalLanes),
      lane,
      sizes.totalRounds
    );
    const numMatches = numberOfMatchesForLane(
      pseudoLane - 1,
      sizes.totalRounds,
      sizes.numberOfMatchesBottomBracket,
      sizes.numberOfLanes
    );
    const bracketName = getNameOfBracket(numMatches);
    const trophyUrl = getTrophyUrlForNumberOfMatches(numMatches);
    const bgColor = getLaneBackgroundColor({
      lane,
      totalLanes,
      sizes,
      nightMode,
    });
    laneHeaders.push(
      <div
        key={lane}
        style={{
          width: sizes.laneW + "px",
          minWidth: sizes.laneW + "px",
          height: sizes.headerHeight + "px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: bgColor,
          borderRight: nightMode ? "1px solid #c2c4c2" : "1px solid #010101",
          boxSizing: "border-box",
          transition: "background 0.2s, border-bottom 0.2s",
        }}
      >
        <img
          src={trophyUrl}
          alt="Bracket Trophy"
          style={{ height: sizes.trophyHeight + "px", marginBottom: "0.5rem" }}
        />
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: sizes.smallFontSize,
              color: nightMode ? "#c2c4c2" : "#010101",
              fontWeight: 700,
              marginBottom: 2,
            }}
          >
            {bracketName}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 5,
        height: sizes.headerHeight + "px",
        width: sizes.screenSizeW + "px",
        minWidth: sizes.screenSizeW + "px",
        background: nightMode ? "#222" : "#fff",
        display: "flex",
        alignItems: "stretch",
        borderBottom: nightMode ? "2px solid #c2c4c2" : "2px solid #010101",
        left: 0,
      }}
    >
      {laneHeaders}
    </div>
  );
}

export default TournamentLaneHeader;
